/*

FILE: forms.js
DESCRIPTION: Custom form events
AUTHOR(S): R.J. LaCount

*/

import { elements } from './elements';
import { getUrlParameter } from './utils';

const setInputStates = (inputs) => {

	inputs.forEach(input => {

		input.addEventListener('blur', (e) => {
			input.value ? input.classList.add('has-value') : input.classList.remove('has-value');
		});
	})
}

const setActiveForm = () => {
	const param = getUrlParameter('showform');

	if (param) {
		const form = 'form-' + param;

		elements.showEls.forEach(el => {
			el.classList.add('hidden');
			if (el.dataset.show === form) el.classList.remove('hidden');
		});
		elements.showTriggers.forEach(el => {
			el.classList.remove('active');
			if (el.dataset.trigger === form) el.classList.add('active');
		});
	}
}

const setFormState = (state, form) => {
	const statusContainer = form.closest('.freeform-container').querySelector('.form-status');

	switch (state) {
		case 'success':
			statusContainer.classList.remove('error');
			statusContainer.classList.add('success');
			window.location.href = "/thank-you";
			break;
		case 'error':
			statusContainer.classList.add('error');

			// reset the button class
			const submitButton = form.querySelector('button[type="submit"]');
			submitButton.classList.remove('loading');
			break;
		default:
			console.log('No state provided.');
	}
}

const freeformAjax = (form) => {

	setTimeout(() => {
		// recaptcha
		const recaptchaKey = window.freeform.recaptchaSiteKey ?? '';
		const recaptchaAction = 'submit';
		const recaptchaElement = form.querySelector('#g-recaptcha-response');

		renderRecaptcha(recaptchaKey, recaptchaAction, recaptchaElement);
	}, 1000);

	// Add the on-submit event listener
	form.addEventListener('submit', ajaxifyForm, false);
	function ajaxifyForm(event) {
		event.preventDefault();

		const form = event.target;

		// set the submit button class to loading
		const submitButton = form.querySelector('button[type="submit"]');
		submitButton.classList.add('loading');

		const data = new FormData(form);
		const method = form.getAttribute('method');
		const action = form.getAttribute('action');
		const recaptchaKey = form.getAttribute('data-recaptcha-key');
		const recaptchaAction = form.getAttribute('data-recaptcha-action');
		const recaptchaElement = form.querySelector('#g-recaptcha-response');

		if (recaptchaElement.value === '') {
			// Pretend to successfully submit
			setTimeout(() => {
				//form.reset();
				setFormState('error', form);
			}, 500);
		} else {
			const request = new XMLHttpRequest();
			request.open(method, action ? action : window.location.href, true);
			request.setRequestHeader("Cache-Control", "no-cache");

			// Set the Craft specific AJAX headers
			request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
			request.setRequestHeader("HTTP_X_REQUESTED_WITH", "XMLHttpRequest");

			request.onload = function () {
				if (request.status === 200) {
					const response = JSON.parse(request.response);

					if (response.success && response.finished) {
						form.reset();
						setFormState('success', form);
					} else if (response.errors || response.formErrors) {
						setFormState('error', form);

						// generate new recaptcha if there is an error
						renderRecaptcha(recaptchaKey, recaptchaAction, recaptchaElement);
					}

					// Update the Honeypot field if using JS enhancement
					if (response.honeypot) {
						var honeypotInput = form.querySelector("input[name^=freeform_form_handle_]");

						if (honeypotInput) {
							honeypotInput.setAttribute("name", response.honeypot.name);
							honeypotInput.setAttribute("id", response.honeypot.name);
							honeypotInput.value = response.honeypot.hash;
						}
					}
				} else {
					console.error(request);
				}
			};

			request.send(data);
		}
	}
}

const renderRecaptcha = (siteKey, action, element) => {
	window.grecaptcha.execute(siteKey, {
		action: action
	}).then((token) => {
		element.value = token;
	});
}

const initFreeformAjax = () => {
	const formContainer = document.querySelector('.freeform-container');

	if (formContainer) {
		//renderRecaptcha();
		const forms = formContainer.querySelectorAll('form');
		forms.forEach(form => {
			freeformAjax(form);
		});
	}
}

export { setInputStates, setActiveForm, initFreeformAjax, renderRecaptcha };
